(() => {
  const init = () => {
    const products = new Map();
    document.querySelectorAll('script[data-sb-product-json]').forEach(script => {
      try {
        const product = JSON.parse(script.textContent);
        if (product && product.id) products.set(String(product.id), product);
      } catch (error) { console.warn('Unable to read product options.', error); }
    });
    const currency = (window.Shopify && window.Shopify.currency && window.Shopify.currency.active) || 'USD';
    const money = cents => new Intl.NumberFormat(document.documentElement.lang || 'en', {style:'currency',currency}).format(cents / 100);
    [...document.querySelectorAll('[data-sb-native-layout]')].filter(root => !root.parentElement.closest('[data-sb-native-layout]')).forEach(root => {
      if (root.dataset.sbNativeReady) return;
      root.dataset.sbNativeReady = 'true';
      root.querySelectorAll('iframe[data-src]').forEach(frame => {
        const source = frame.dataset.src;
        if (!frame.getAttribute('src') && source && /^https?:\/\//.test(source)) frame.src = source;
      });
      root.querySelectorAll('[data-action="url"][data-href]').forEach(item => {
        if (item.closest('a')) return;
        item.tabIndex = 0;
        item.setAttribute('role','link');
        const open = () => {
          if (item.dataset.target === '_blank') window.open(item.dataset.href, '_blank', 'noopener,noreferrer');
          else window.location.assign(item.dataset.href);
        };
        item.addEventListener('click', open);
        item.addEventListener('keydown', event => {
          if (event.key === 'Enter') { event.preventDefault(); open(); }
        });
      });
      root.querySelectorAll('.pf-product-form').forEach(form => {
        const product = products.get(String(form.dataset.productid || form.querySelector('[data-product-id]')?.dataset.productId));
        if (!product || !product.variants?.length) return;
        let input = form.querySelector('input[name="id"]');
        if (!input) {
          input = document.createElement('input');
          input.type = 'hidden'; input.name = 'id'; form.appendChild(input);
        }
        const requested = new URLSearchParams(window.location.search).get('variant');
        const initial = product.variants.find(variant => String(variant.id) === (requested || input.value)) || product.variants.find(variant => variant.available) || product.variants[0];
        input.value = initial.id;
        const update = variant => {
          if (!variant) return;
          input.value = variant.id;
          form.querySelectorAll('[data-pf-type="ProductATC"],[data-pf-type="ProductATC2"]').forEach(button => {
            button.type = 'submit';
            button.disabled = !variant.available;
            button.setAttribute('aria-disabled', String(!variant.available));
            const soldOut = button.dataset.soldout || window.sbNativeStrings?.soldOut || window.theme?.strings?.soldOut;
            if (!button.dataset.sbAvailableLabel && button.textContent.trim() !== soldOut) button.dataset.sbAvailableLabel = button.textContent.trim();
            if (!variant.available) button.textContent = soldOut;
            else if (button.textContent.trim() === soldOut) button.textContent = button.dataset.sbAvailableLabel || window.sbNativeStrings?.addToCart || window.theme?.strings?.addToCart;
          });
          if (product.variants.length > 1) {
            root.querySelectorAll('[data-product-id="' + product.id + '"][data-product-type="price"]').forEach(price => {price.textContent = money(variant.price);});
            root.querySelectorAll('[data-product-id="' + product.id + '"][data-product-type="compare_at_price"]').forEach(price => {price.textContent = variant.compare_at_price > variant.price ? money(variant.compare_at_price) : '';});
          }
          if (variant.featured_media?.id) {
            root.querySelectorAll('[data-pf-type="ProductMedia2"],[data-pf-type="ProductMedia3"]').forEach(gallery => {
              if (gallery.dataset.productId !== String(product.id)) return;
              gallery.querySelector('[data-pf-type="MediaList2"] [data-media-id="' + variant.featured_media.id + '"]')?.click();
            });
          }
        };
        update(initial);
        form.addEventListener('change', event => {
          if (event.target.matches('input[type="radio"]')) update(product.variants.find(variant => String(variant.id) === event.target.value));
        });
      });
      root.querySelectorAll('[data-pf-type="ProductMedia2"],[data-pf-type="ProductMedia3"]').forEach(gallery => {
        const main = [...gallery.querySelectorAll('.pf-slide-main-media')];
        const thumbnails = [...gallery.querySelectorAll('.pf-slide-list-media')];
        if (!main.length) return;
        let index = Math.max(0,main.findIndex(slide => slide.classList.contains('pf-selected')));
        const show = next => {
          index = (next + main.length) % main.length;
          main.forEach((slide,i) => {
            slide.setAttribute('aria-hidden',String(i !== index));
            if (i !== index) slide.querySelectorAll('video').forEach(video => video.pause());
          });
          thumbnails.forEach(thumb => thumb.setAttribute('aria-current',String(thumb.dataset.mediaId === main[index].dataset.mediaId)));
        };
        thumbnails.forEach((thumb,i) => {
          thumb.tabIndex = 0; thumb.setAttribute('role','button'); thumb.setAttribute('aria-label',window.sbNativeStrings.showImage.replace('__number__', String(i+1)));
          const select = () => {const found=main.findIndex(slide => slide.dataset.mediaId === thumb.dataset.mediaId);show(found < 0 ? i : found);};
          thumb.addEventListener('click',select);
          thumb.addEventListener('keydown',event => {if (['Enter',' '].includes(event.key)) {event.preventDefault();select();}});
        });
        gallery.querySelectorAll('.pf-slider-prev').forEach(button => {button.style.visibility='visible';button.addEventListener('click',()=>show(index-1));});
        gallery.querySelectorAll('.pf-slider-next').forEach(button => {button.style.visibility='visible';button.addEventListener('click',()=>show(index+1));});
        show(index);
      });
      root.querySelectorAll('[data-pf-type="Tabs3"],[data-pf-type="Tabs"]').forEach(tabs => {
        const radios=[...tabs.querySelectorAll('.pf-tab-radio')];
        radios.forEach(radio => radio.addEventListener('change',()=> {
          tabs.querySelectorAll('label[for]').forEach(label => label.dataset.pfTabActive=String(label.htmlFor===radio.id));
        }));
      });
      root.querySelectorAll('[data-pf-type="Accordion"]').forEach(accordion => {
        const headers = [...accordion.querySelectorAll('[data-pf-type="Accordion.Header"]')];
        const toggle = (header,open) => {
          const content = header.closest('[data-pf-type="Accordion.Content.Wrapper"]')?.querySelector('.pf-accordion-wrapper');
          if (!content) return;
          header.dataset.active = String(open);
          header.setAttribute('aria-expanded',String(open));
          content.classList.toggle('pf-accordion-hide',!open);
          content.hidden = !open;
          content.style.height = open ? 'auto' : '0px';
        };
        headers.forEach(header => {
          toggle(header,header.dataset.active==='true');
          header.addEventListener('click',()=> {
            const open=header.dataset.active!=='true';
            if(accordion.dataset.multiple!=='true') headers.forEach(other=>{if(other!==header) toggle(other,false);});
            toggle(header,open);
          });
        });
      });
    });
  };
  if(document.readyState==='loading') document.addEventListener('DOMContentLoaded',init,{once:true});
  else init();
  document.addEventListener('shopify:section:load',init);
})();

(function () {
  function enhanceHomepage() {
    document.querySelectorAll('footer a[title="Facebook"], footer a[title="Instagram"], footer a[title="Linkedin"], footer a[title="YouTube"], footer a[title="Vimeo"]').forEach(function (link) {
      if (link.getAttribute('title') === 'Instagram') link.href = 'https://www.instagram.com/solutionbased_inc/';
      link.target = '_blank'; link.rel = 'noopener noreferrer';
    });
    var root = document.querySelector('[data-section-id="pf-5755"] [data-pf-type="Slideshow"]');
    if (!root || root.classList.contains('sb-m1-fade')) return;
    var gallerySlides = Array.from(root.querySelectorAll('.pf-slide'));
    var slides = gallerySlides.slice();
    if (slides.length < 2) return;
    for (var shuffleIndex = slides.length - 1; shuffleIndex > 0; shuffleIndex--) {
      var randomIndex = Math.floor(Math.random() * (shuffleIndex + 1));
      var currentSlide = slides[shuffleIndex];
      slides[shuffleIndex] = slides[randomIndex];
      slides[randomIndex] = currentSlide;
    }
    var cushionSlides = slides.filter(function (slide) {
      return slide.querySelector('img').src.indexOf('metapal-custom-visco-cushion-') !== -1;
    });
    var chairSlides = slides.filter(function (slide) {
      return cushionSlides.indexOf(slide) === -1;
    });
    if (cushionSlides.length && chairSlides.length) {
      slides = [];
      chairSlides.forEach(function (chair, chairIndex) {
        slides.push(cushionSlides[chairIndex % cushionSlides.length], chair);
      });
    }
    root.classList.add('sb-m1-fade');
    root.setAttribute('role', 'region');
    root.setAttribute('aria-label', window.sbNativeStrings.gallery);
    var paused = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    var index = 0;
    var toggle = document.createElement('button');
    toggle.type = 'button'; toggle.className = 'sb-slide-toggle';
    function updateToggle() { toggle.textContent = paused ? '▶' : 'Ⅱ'; toggle.setAttribute('aria-label', paused ? window.sbNativeStrings.play : window.sbNativeStrings.pause); }
    function showSlide(next) { gallerySlides.forEach(function (slide) { var active = slide === slides[next]; slide.classList.toggle('sb-fade-active', active); slide.setAttribute('aria-hidden', String(!active)); }); }
    updateToggle(); showSlide(0); root.appendChild(toggle);
    toggle.addEventListener('click', function () { paused = !paused; updateToggle(); });
    root.querySelectorAll('img').forEach(function (image) { image.loading = 'eager'; });
    setInterval(async function () {
      if (paused || document.hidden) return;
      var next = (index + 1) % slides.length;
      var image = slides[next].querySelector('img');
      if (image) {
        try { await image.decode(); } catch (error) { return; }
      }
      if (paused || document.hidden) return;
      index = next;
      showSlide(index);
    }, 3500);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', enhanceHomepage); else enhanceHomepage();
})();
(() => {
  const init = () => {
    const root = document.querySelector('#recent-reviews .jdgm-carousel-wrapper');
    if (!root || root.dataset.sbReviewsReady) return;
    root.dataset.sbReviewsReady = 'true';
    const track = root.querySelector('.jdgm-carousel__item-wrapper');
    const productSource = document.querySelector('#sb-product-reviews-source');
    if (track && productSource) {
      const createText = (className, text) => {
        const element = document.createElement('div');
        element.className = className;
        element.textContent = text;
        return element;
      };
      const signature = card => [
        card.querySelector('.jdgm-carousel-item__reviewer-name')?.textContent,
        card.querySelector('.jdgm-carousel-item__review-title')?.textContent,
        card.querySelector('.jdgm-carousel-item__review-body')?.textContent
      ].map(text => (text || '').replace(/\s+/g, ' ').trim().toLowerCase()).join('|');
      const productCards = Array.from(productSource.content.querySelectorAll('.jdgm-rev')).map(review => {
        const card = document.createElement('div');
        card.className = 'jdgm-carousel-item';
        card.dataset.reviewId = review.dataset.reviewId || '';
        const inner = document.createElement('div');
        inner.className = 'jdgm-carousel-item__inner-wrapper';
        const content = document.createElement('div');
        content.className = 'jdgm-carousel-item__review';
        const rating = document.createElement('div');
        rating.className = 'jdgm-carousel-item__review-rating';
        const sourceRating = review.querySelector('.jdgm-rev__rating');
        if (sourceRating) {
          rating.setAttribute('role', 'img');
          rating.setAttribute('aria-label', sourceRating.getAttribute('aria-label') || '');
          sourceRating.querySelectorAll('.jdgm-star').forEach(star => rating.appendChild(star.cloneNode(true)));
        }
        content.appendChild(rating);
        content.appendChild(createText('jdgm-carousel-item__review-title', review.querySelector('.jdgm-rev__title')?.textContent || ''));
        const body = createText('jdgm-carousel-item__review-body', '');
        body.appendChild(createText('jdgm-carousel-item__review-body-text', review.querySelector('.jdgm-rev__body')?.textContent || ''));
        content.appendChild(body);
        inner.appendChild(content);
        const author = createText('jdgm-carousel-item__reviewer-name-wrapper', '');
        author.appendChild(createText('jdgm-carousel-item__reviewer-name', review.querySelector('.jdgm-rev__author')?.textContent || ''));
        inner.appendChild(author);
        card.appendChild(inner);
        return card;
      });
      const productSignatures = new Set(productCards.map(signature));
      const otherCards = Array.from(track.querySelectorAll('.jdgm-carousel-item')).filter(card => !productSignatures.has(signature(card)));
      track.replaceChildren(...productCards, ...otherCards.slice(0, Math.max(0, 20 - productCards.length)));
    }
    const additionalReviews = document.querySelector('#sb-additional-home-reviews');
    if (track && additionalReviews) {
      const remaining = Math.max(0, 20 - track.querySelectorAll('.jdgm-carousel-item').length);
      Array.from(additionalReviews.content.children).slice(0, remaining).forEach(card => {
        const clone = card.cloneNode(true);
        track.appendChild(clone);
      });
    }
    const buttons = document.querySelectorAll('#recent-reviews [data-review-direction]');
    const updateControls = () => {
      if (!track) return;
      buttons.forEach(button => {
        button.disabled = Number(button.dataset.reviewDirection) < 0
          ? track.scrollLeft <= 2
          : track.scrollLeft >= track.scrollWidth - track.clientWidth - 2;
      });
    };
    if (track) {
      buttons.forEach(button => button.addEventListener('click', () => {
        const card = track.querySelector('.jdgm-carousel-item');
        if (!card) return;
        const step = card.getBoundingClientRect().width + parseFloat(getComputedStyle(track).gap || 0);
        track.scrollBy({
          left: Number(button.dataset.reviewDirection) * step,
          behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth'
        });
      }));
      track.addEventListener('scroll', updateControls, { passive: true });
      new ResizeObserver(updateControls).observe(track);
    }
    const labels = root.closest('#recent-reviews').dataset;
    const updateExcerpts = () => {
      root.querySelectorAll('.jdgm-carousel-item__review-body').forEach((body, index) => {
        body.classList.add('sb-review-collapsible');
        const longReview = body.classList.contains('sb-review-expanded') || body.scrollHeight > body.clientHeight + 1;
        let toggle = body.parentElement.querySelector('.sb-review-toggle');
        if (!toggle && longReview) {
          if (!body.id) body.id = 'sb-home-review-body-' + (index + 1);
          toggle = document.createElement('button');
          toggle.type = 'button';
          toggle.className = 'sb-review-toggle';
          toggle.textContent = labels.sbReviewReadMore;
          toggle.setAttribute('aria-expanded', 'false');
          toggle.setAttribute('aria-controls', body.id);
          toggle.addEventListener('click', event => {
            event.stopPropagation();
            const expanded = toggle.getAttribute('aria-expanded') !== 'true';
            body.classList.toggle('sb-review-expanded', expanded);
            toggle.setAttribute('aria-expanded', String(expanded));
            toggle.textContent = expanded ? labels.sbReviewShowLess : labels.sbReviewReadMore;
          });
          body.insertAdjacentElement('afterend', toggle);
        }
        if (toggle) toggle.hidden = !longReview;
      });
    };
    let excerptFrame;
    const scheduleExcerpts = () => {
      cancelAnimationFrame(excerptFrame);
      excerptFrame = requestAnimationFrame(updateExcerpts);
    };
    updateControls();
    scheduleExcerpts();
    new ResizeObserver(scheduleExcerpts).observe(root);
    new MutationObserver(scheduleExcerpts).observe(root, { childList: true, subtree: true });
    document.fonts?.ready.then(scheduleExcerpts);
  };
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init, { once: true });
  } else {
    init();
  }
})();


(() => {
  const setupReviewPhotos = () => {
    if (!document.body.classList.contains('template-product')) return;
    const root = document.querySelector('#MainContent');
    if (!root || root.dataset.sbReviewPhotosReady) return;
    root.dataset.sbReviewPhotosReady = 'true';
    const enhance = () => {
      root.querySelectorAll('.jdgm-cards-carousel .jdgm-media-card').forEach(card => {
        const image = card.querySelector(':scope > img');
        if (!image) return;
        let button = card.querySelector(':scope > .sb-review-photo-button');
        if (!button) {
          button = document.createElement('button');
          button.type = 'button';
          button.className = 'sb-review-photo-button';
          button.setAttribute('aria-label', 'View review photos');
          button.setAttribute('aria-haspopup', 'dialog');
          button.title = 'View review photos';
          const svg = document.createElementNS('http://www.w3.org/2000/svg', 'svg');
          svg.setAttribute('viewBox', '0 0 24 24');
          svg.setAttribute('aria-hidden', 'true');
          svg.setAttribute('fill', 'none');
          svg.setAttribute('stroke', 'currentColor');
          svg.setAttribute('stroke-width', '1.7');
          const path = document.createElementNS('http://www.w3.org/2000/svg', 'path');
          path.setAttribute('d', 'M8 5l1.5-2h5L16 5h4a1 1 0 011 1v14a1 1 0 01-1 1H4a1 1 0 01-1-1V6a1 1 0 011-1z');
          const circle = document.createElementNS('http://www.w3.org/2000/svg', 'circle');
          circle.setAttribute('cx', '12');
          circle.setAttribute('cy', '13');
          circle.setAttribute('r', '4');
          svg.append(path, circle);
          button.appendChild(svg);
          card.appendChild(button);
        }
        button.tabIndex = card.closest('[aria-hidden="true"]') ? -1 : 0;
        card.classList.add('sb-review-photo-card');
      });
    };
    root.addEventListener('click', event => {
      const button = event.target.closest?.('.sb-review-photo-button');
      if (!button || !root.contains(button)) return;
      const image = button.parentElement.querySelector(':scope > img');
      if (!image) return;
      event.preventDefault();
      event.stopPropagation();
      image.click();
    }, true);
    enhance();
    let scheduled = false;
    new MutationObserver(mutations => {
      const changed = mutations.some(mutation =>
        mutation.target.closest?.('.jdgm-cards-carousel') ||
        Array.from(mutation.addedNodes).some(node => node.nodeType === 1 &&
          (node.matches('.jdgm-cards-carousel') || node.querySelector('.jdgm-cards-carousel')))
      );
      if (!changed || scheduled) return;
      scheduled = true;
      requestAnimationFrame(() => {
        scheduled = false;
        enhance();
      });
    }).observe(root, {childList: true, subtree: true, attributes: true, attributeFilter: ['aria-hidden']});
  };
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', setupReviewPhotos, {once: true});
  } else {
    setupReviewPhotos();
  }
})();


